function isFormControl(element) {
  return ['INPUT', 'TEXTAREA', 'SELECT'].includes(element?.tagName);
}

export function readDocumentField(element, trim = true) {
  if (!element) return '';
  const value = isFormControl(element)
    ? String(element.value ?? '')
    : String(element.innerText ?? element.textContent ?? '');
  return trim ? value.trim() : value;
}

export function writeDocumentField(element, value) {
  if (!element) return;
  if (isFormControl(element)) {
    element.value = value;
    return;
  }
  element.innerText = value;
}

export function mirrorDocumentField(frameDocument, source) {
  const field = source?.getAttribute?.('data-field');
  if (!frameDocument || !field) return;
  const value = readDocumentField(source, false);
  frameDocument.querySelectorAll('[data-field]').forEach((target) => {
    if (target !== source && target.getAttribute('data-field') === field) {
      writeDocumentField(target, value);
    }
  });
}

export function collectDocumentFields(frameDocument) {
  const fields = {};
  if (!frameDocument) return fields;

  frameDocument.querySelectorAll('[data-field]').forEach((element) => {
    const field = element.getAttribute('data-field');
    if (field && !(field in fields)) fields[field] = readDocumentField(element);
  });
  frameDocument.querySelectorAll('[data-toggle]').forEach((element) => {
    const field = element.getAttribute('data-toggle');
    if (field) fields[field] = Boolean(element.checked);
  });

  return fields;
}

export function selectDocumentFields(fields, selectedNames) {
  const selected = selectedNames instanceof Set ? selectedNames : new Set(selectedNames || []);
  return Object.fromEntries(
    Object.entries(fields || {}).filter(([field]) => selected.has(field)),
  );
}

export function setDocumentEditHighlights(frameDocument, visible) {
  frameDocument
    ?.querySelector('[data-document-editor]')
    ?.classList.toggle('show-edit', Boolean(visible));
}
